
import React from 'react'
import Dialog from './Dialog'
import Button from './Button'
import Paragraph from './Paragraph'

/**
 * ConfirmationDialog component.
 */

export default function ConfirmationDialog({ onConfirm, text, theme = 'primary', closeLabel = 'Cancel', confirmLabel = 'Confirm', ...props }) {
  return <Dialog {...props}>
    {({ close }) => {
      return <React.Fragment>
        <Paragraph margin={6}>{text}</Paragraph>
        <Dialog.Actions>
          <Button onClick={close}>{closeLabel}</Button>
          <Button theme={theme} onClick={_ => (onConfirm(), close())}>{confirmLabel}</Button>
        </Dialog.Actions>
      </React.Fragment>
    }}
  </Dialog>
}